// import AppNavbar from "../../Navbar/AppNavbar"
import AppLayout from "../../Navbar/AppLayout";
import Footer from "../../Navbar/Footer";
import '../../../assets/css/search.scss'
import '../../../assets/css/viewedContacts.scss'
import { useRef, useState, useEffect } from "react";
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { useDispatch, useSelector } from "react-redux";
import ViewedContactsTable from "./ViewedContactsTable";
import { downloadViewedContactsDatas, loadViewedContactsData } from "../../redux/action";
import { Circles } from "react-loader-spinner";

const ViewedContacts = () => {
    const dispatch = useDispatch();
    const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails"));
    const signInID = signInDetails[0]?.id;
    const sbnID = signInDetails[0]?.sbn_id;
    const role = signInDetails[0]?.role;

    const { getViewedContacts = [] } = useSelector((state) => state.data);
    const { totalDataCount } = useSelector((state) => state.data);

    const [tableHeight, setTableHeight] = useState(0);

    const [loading, setLoading] = useState(false);
    const rowsPerPage = 20;
    const [page, setPage] = useState(1);
    const [loadingMore, setLoadingMore] = useState(false);
    const [selectedRowsData, setSelectedRowsData] = useState([]); // array of full selected row objects
    const [downloading, setDownloading] = useState(false)

    useEffect(() => {
        fetchViewedContact();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]);

    const fetchViewedContact = () => {
        dispatch(loadViewedContactsData(signInID, sbnID, 'Default', role, page, rowsPerPage, setLoading));
    }

    const divRef = useRef(null);
    const div1Ref = useRef(null);
    const div2Ref = useRef(null);
    const [height1, setHeight1] = useState(0);
    const [height2, setHeight2] = useState(0);

    useEffect(() => {
        if (div1Ref.current) {
            setHeight1(div1Ref.current.offsetHeight);
        }
        if (div2Ref.current) {
            setHeight2(div2Ref.current.offsetHeight);
        }
    }, []);

    useEffect(() => {
        if (!divRef.current) return;

        const parentHeight = divRef.current.offsetHeight;

        const pixelAdjustment = height1 + height2 + 40;

        const tablePxHeight = parentHeight - pixelAdjustment;

        setTableHeight(tablePxHeight);
    }, [height1, height2]);

    const handleDownload = () => {
        dispatch(downloadViewedContactsDatas(signInID, sbnID, 'Default', role, setDownloading, fetchViewedContact));
    };


    return (
        <div className="page-layout" style={{ position: "relative" }}>
            {/* <AppNavbar /> */}
            <AppLayout>
            <div className="page-content">
                <div className="viewed-contacts-container" ref={divRef} style={{ height: '100%' }}>
                    <div className="viewed-contacts-div">
                        <div className="viewed-contacts-header" ref={div1Ref}>
                            <p>Viewed</p>
                            <div className="viewed-contacts-view-img-div">
                                <h5>Contacts</h5>
                                <i class="fa-regular fa-eye"></i>
                            </div>
                        </div>
                        <ViewedContactsTable
                            page={page}
                            setPage={setPage}
                            rowsPerPage={rowsPerPage}
                            totalDataCount={totalDataCount}
                            loading={loading}
                            fetchViewedContact={fetchViewedContact}
                            loadingMore={loadingMore}
                            setLoadingMore={setLoadingMore}
                            tableHeight={tableHeight}
                            selectedRowsData={selectedRowsData}
                            setSelectedRowsData={setSelectedRowsData}
                            getViewedContacts={getViewedContacts}
                            div2Ref={div2Ref}
                            handleDownload={handleDownload}
                            signInID={signInID}
                            sbnID={sbnID}
                            role={role}
                        />
                    </div>
                </div>
            </div>
             </AppLayout>
            {downloading && (
                <div className="download-overlay">
                    <div className="download-loader-content">
                        <Circles
                            height="30"
                            width="30"
                            color="#007bff"
                            ariaLabel="circles-loading"
                            visible={true}
                        />
                        <span className="ms-2">Downloading, please wait...</span>
                    </div>
                </div>
            )}
           
            <Footer />
        </div>
    )
}

export default ViewedContacts;